import { DocumentItemPartial, DocumentItemTypeEnum } from '@domain';
import { RaImageFullScreenModel } from 'ra-ui';
import { deltaToPlainText } from 'src/app/shared/utils/delta.util';

export interface SectionGallery {
    images: RaImageFullScreenModel[];
    startIndex: number;
}

/**
 * Monta a galeria de tela cheia com TODAS as imagens da seção — campos IMAGE
 * e mídias dos GROUP_IMAGE, na ordem do documento — para navegar entre elas
 * igual ao preview.
 *
 * @param items Itens da seção atual
 * @param targetFieldId Campo clicado (posiciona a galeria nele)
 * @param targetMediaIndex Índice da mídia dentro do grupo clicado
 * @param fallbackAlt Texto alternativo quando o campo não tem descrição
 */
export function buildSectionGallery(
    items: DocumentItemPartial[],
    targetFieldId: string,
    targetMediaIndex = 0,
    fallbackAlt = ''
): SectionGallery {
    const images: RaImageFullScreenModel[] = [];
    let startIndex = 0;

    for (const item of items ?? []) {
        const description = deltaToPlainText(item.description) || fallbackAlt;

        if (
            item.type === DocumentItemTypeEnum.IMAGE &&
            typeof item.value === 'string' &&
            item.value
        ) {
            if (item._id === targetFieldId) startIndex = images.length;
            images.push({ url: item.value, alt: description, title: description });
        } else if (item.type === DocumentItemTypeEnum.GROUP_IMAGE && Array.isArray(item.value)) {
            item.value.forEach((media: { url?: string }, index: number) => {
                if (!media?.url) return;
                if (item._id === targetFieldId && index === targetMediaIndex) {
                    startIndex = images.length;
                }
                images.push({ url: media.url, alt: description, title: description });
            });
        }
    }

    return { images, startIndex };
}
